const config = {
  appName: "District Nirikshan Admin",
  apiUrl: process.env.REACT_APP_API_URL || "/api/",
  relativePath: process.env.REACT_APP_RELATIVE_PATH || "",
  frontDomain: process.env.REACT_APP_FRONT_DOMAIN || "localhost",

  encryption: { apiSecret: process.env.REACT_APP_API_SECRET },

  feedbackQuestionTypes: [
    { value: "yesno", label: "Yes or No" },
    { value: "options", label: "Multiple Choice" },
    { value: "writenumber", label: "Numeric Input" },
    { value: "writetext", label: "Text Response" },
    // { value: "media", label: "Media" },
  ],
};

export default config;
